export default function getDocumentTypeValue(documentType) {
  switch (documentType) {
    case "1":
      return "TX"
    case "2":
      return "AB"
    case "3":
      return "DR"
    case "4":
      return "CR"
    case "5":
      return "RE"
    case "6":
      return "RT"
    default:
      return ""
  }
}
